export default __webpack_public_path__ + "77be4aa5f908ea85e367c8b9ae0cdcc4.png";